<template>
  <div>
    <van-sticky>
      <cooperation-search-head
        :titleInfo="titleInfo"
        @handSearch="handSearch"
        :showBg="false"
        :companyList="companyList"
      >
      </cooperation-search-head>
    </van-sticky>
    <nav-title title="招标信息列表"></nav-title>
    <div class="recruit-list">
      <van-list
        :offset="30"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item, index) in list" :key="index">
          <template>
            <div class="recruit-item" @click="handInfo(item.tenderingGuid)">
              <div class="sub-title">
                <span style="line-height:1.5">{{ item.bidnoticetitle }}</span>
                <div>
                  <Icon
                    :name="item.status == '1' ? '报名中' : '已截止'"
                    :status="item.status"
                  ></Icon>
                </div>
              </div>
              <div class="rest-detail tendering">
                <div>
                  <span>所属公司：</span><span>{{ item.theirCompany }}</span>
                </div>
                <div>
                  <span>所属项目：</span><span>{{ item.projname }}</span>
                </div>
                <div>
                  <span>发布日期：</span
                  ><span>{{
                    item.releaseDate &&
                      moment(item.releaseDate).format('YYYY-MM-DD')
                  }}</span>
                </div>
                <div>
                  <span>截止日期：</span
                  ><span>{{
                    item.signupendtime &&
                      moment(item.signupendtime).format('YYYY-MM-DD')
                  }}</span>
                </div>
              </div>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import navTitle from './recruit-title';
import Icon from './sing-up-status';
import cooperationSearchHead from '../../cooperation-packge/components/cooperation-search-head-cp';
import { List, PullRefresh, Sticky } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

import moment from 'moment';
export default {
  components: {
    navTitle,
    Icon,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      index: 1,
      list: [],
      current: 1,
      size: 10,
      loading: false,
      finished: false,
      refreshing: false,
      moment,
      companyList: [],
      titleInfo: {
        selectname: '报名截止日期',
        selectTitle: '报名截止日期'
      }
    };
  },
  props: {
    _index: {
      type: String,
      default: '0'
    }
  },
  created() {
    this._getBiddingList();
  },
  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item.name,
                value: item.id
              };
            });
          }
        });
    },
    _getBiddingList(params = {}) {
      let { current, size } = this;
      params = { ...params, current, size };
      this.$api.getBiddingList(params).then(res => {
        let { code, body } = res;
        if (code == '0000') {
          let { records } = body;
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    onLoad() {
      let { params } = this;
      this.current++;
      this._getBiddingList(params);
    },
    onRefresh() {
      this.finished = false;
      this.list = [];
      this.current = 1;
      this._getBiddingList();
    },
    handSearch(data) {
      this.list = [];
      let params = { ...data, current: 1 };
      this.params = params;
      this.current = 1;
      this.loading = false;
      this.finished = false;
      this._getBiddingList(params);
    },
    handInfo(tenderingGuid) {
      this.$router.push({
        name: 'tenderingNoticeDetail',
        query: {
          tenderingGuid
        }
      });
    }
  },
  watch: {
    _index: {
      handler: function() {
        this._getComplay({ type: 'bidding' });
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.recruit-list {
  padding: 0px 32px;
  padding-right: 0px;
  background: #fff;
  /deep/ .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0px;
    overflow: hidden;
    color: #323233;
    font-size: 0.28rem;
    line-height: 1;
    background-color: #fff;
  }
  .recruit-item {
    border-bottom: 1px solid #efefef;
    padding: 30px 0px;
    .sub-title {
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        color: #000;
        font-size: 32px;
        font-weight: 500;
      }
    }
    .rest-detail {
      margin-top: 20px;
      color: #666666;
      font-size: 26px;
      > div {
        line-height: 1.8;
      }
    }
    .tendering {
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 45%;
      }
    }
  }
}
</style>
